import React from "react";

//Please remember to update the html if the document/pdf changes.
export const LicenseAgreement = () => {
  return (
    <div>
      1. Subject to the terms and conditions of this End-User License and
      Agreement (“License”), Diligent Delivery Systems (“Diligent”) grants you
      (“End-User,” “You,” “Your”) a non-exclusive, non-assignable,
      non-transferable, limited, revocable license to the use of the program,
      software and application “Parts Delivery Logistics Integrator TM” (“PDLI”)
      solely for the purpose of integrating, optimizing, and linking Your
      Diligent shipping data with data You input and maintain in Your ERP
      (Enterprise Resource Planning System) to streamline and maximize Your
      Diligent delivery and logistics services. 2. This License is subject to
      the following restrictions: a. The geographic scope of this License is
      limited to the states and territories of the United States of America. b.
      This License is personal to You and no rights to sublicense, transfer, or
      assign PDLI is granted nor allowed without the prior written consent of
      Diligent and any attempt to sublicense, transfer, or assign PDLI without
      such prior written consent will be a breach of this License and shall be
      null and void. c. This License does not permit, and You agree that You
      will not (nor will You allow any employee, contractor, or other
      third-party to): i. Copy, duplicate, publish, or infringe PDLI. ii. Make
      or produce (or have made or produced) any derivative works or disassemble,
      reverse engineer, decompile or otherwise copy and/or modify PDLI. iii. In
      any way obtain the PDLI source code or source listings and all such code
      and listings are and remain Diligent trade secrets. iv. Reproduce,
      broadcast, display, or disseminate PDLI. v. Transfer or allow others not
      subject to an end-user license and agreement with Diligent to use PDLI for
      their own use. vi. Remove any copyright notice, Diligent trademarks or
      tradenames, or other indices of ownership from PDLI. d. You represent,
      promise, and warrant that You are not located in an embargoed country, are
      not a Specially Designated National, not a U.S. Denied Persons, and are
      not under control of any entity or individual that is located in such
      embargoed country(ies) or is a U.S. Denied Persons or a Specially
      Designated National. 3. The term of this License is for four (4) months
      from the date it is issued (one royalty-free initial month for first-time
      users and then a three (3) month term). The License shall automatically
      renew for successive One (1) month terms unless You provide a thirty (30)
      day written notice to Diligent to terminate this License (You shall be
      responsible for the thirty (30) day license fee). You authorize Diligent
      to contact any third-party service providers that are integrated into/with
      PDLI to terminate such interface. 4. The royalty and use fee for Your use
      of PDLI is Six Hundred Dollars ($600.00) per month payable and due one
      month in advance. However, if You are a first-time user, Your initial
      month will be royalty-free and, during that month, You may terminate that
      initial one (1) month term at any time by written notice to Diligent. 5.
      You will promptly notify Diligent should You become aware of or suspect a
      third-party of any unauthorized use of PDLI. Diligent reserves the right,
      and You consent, to terminate this License and/or any use should Diligent
      have a good faith belief that You or someone affiliated with You is
      engaged in an unauthorized use of PDLI, breach of this License, or other
      potential or actual acts of infringement. 6. You shall not, and are
      prohibited from any, export or re-export PDLI or any copy thereof. You
      shall not use PDLI in support of, or share with, any business, company, or
      individual that is (i) listed as a Special Designated National (“SDN”) or
      (ii) U.S. Denied Persons by OFAC, U.S. Treasury Department, and/or U.S.
      Department of Commerce. 7. All rights, title, and interests in PDLI
      (including trade secrets, trademarks, patents, copyrights, and other
      intellectual property rights) in PDLI are owned exclusively by Diligent.
      Except for this limited, personal, terminable, non-exclusive license
      granted to You under this License, You have no title, right, or interest
      in PDLI. 8. Diligent, at its sole discretion, may choose to make any
      repair, upgrade, or modification to PDLI including, but not limited to,
      disabling, removing, or ceasing support of or access to PDLI and/or
      terminating this License in accordance with the terms contained herein.
      You are advised to back-up data and information You input and/or store on
      PDLI. 9. You recognize and acknowledge that You are responsible for
      providing Your own supplies, maintenance, tools, or support to use PDLI
      and that PDLI is licensed “AS-IS” without any warranty. All warranties
      including but not limited to all federal and state express or implied
      warranties including implied warranties of merchantability,
      non-infringement, and fitness for a particular purpose, are hereby
      disclaimed, excluded, and are of no effect and are not binding upon
      Diligent. 10. You hereby understand and You expressly accept that Your
      sole remedy arising out of or in relation to this License is for You to
      cease using PDLI. Any claim for damages or any kind whatsoever including
      negligence, warranty, contract, tort, product liability, or statutory
      and/or strict liability shall be limited and capped at the total of three
      (3) months royalty and use fee that You paid prior to the date of such
      claim for damages. 11. This License shall be governed by and construed in
      accordance with the laws of the United States of America, and the State of
      Texas. Any and all litigation will be brought in a court of competent
      jurisdiction in Harris County, Texas and You and Diligence hereby
      expressly submit to such exclusive jurisdiction. You will defend and
      indemnify Diligent from and against any claims, suits, investigations,
      penalties, damages, expenses, fines, judgements and other liabilities
      arising out of Your negligent or intentional acts or omissions, any breach
      of this License by You, or any violation of any law, rule, statue, or
      regulation by You. 12. This License constitutes the entire agreement
      between You and Diligent with respect to PDLI and Diligent services and
      supersedes any prior or contemporaneous representations, statements,
      agreements, license, and/or contracts.
    </div>
  );
};
